export default __webpack_public_path__ + "static/media/login_waves_mobile.7907e0cf.svg";